// Ordenar no mesmo jeito dos filtros (dono, 26/10/2026). `ordem` é o sortBy
// da página: "alfabetica-az|za", "preco-maior|menor", "cmv-maior|menor".
import React from "react";
import { ArrowDown, ArrowUp, ArrowUpDown } from "lucide-react";

const CAMPOS = [
  { campo: "alfabetica", rotulo: "Nome" },
  { campo: "preco", rotulo: "Preço" },
  { campo: "cmv", rotulo: "CMV" },
];

export default function Ordenacao({ ordem, aoOrdenar, filtrosAtivos, aoLimpar }) {
  return (
    <div className="flex items-end justify-between gap-3 pt-2 border-t">
      <div>
        <div className="flex items-center gap-1 mb-1 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
          <ArrowUpDown className="w-3 h-3" /> Ordenar
        </div>
        <div className="flex rounded-md bg-muted/70 p-0.5 gap-0.5" role="radiogroup" aria-label="Ordenar">
          {CAMPOS.map(({ campo, rotulo }) => {
            const marcado = ordem.startsWith(campo);
            const desce = ordem.endsWith("-maior") || ordem === "alfabetica-za";
            const Seta = desce ? ArrowDown : ArrowUp;
            const texto = campo === "alfabetica" && marcado ? (desce ? "Z-A" : "A-Z") : rotulo;
            return (
              <button key={campo} type="button" role="radio" aria-checked={marcado}
                data-e2e={`ordenar-${campo}`} onClick={() => aoOrdenar(campo)}
                title={marcado ? (campo === "alfabetica" ? "Clique para inverter" : desce ? "Maior primeiro" : "Menor primeiro") : `Ordenar por ${rotulo.toLowerCase()}`}
                className={`h-7 px-3 rounded text-[11px] transition-all flex items-center gap-1 ${
                  marcado ? "bg-primary text-primary-foreground font-semibold shadow-sm" : "text-muted-foreground hover:bg-background/70 hover:text-foreground"
                }`}>
                {texto}
                {marcado && campo !== "alfabetica" && <Seta className="w-3 h-3" />}
              </button>
            );
          })}
        </div>
      </div>
      {filtrosAtivos > 0 && (
        <button type="button" className="h-7 px-2 text-[11px] font-medium text-red-500 hover:text-red-600" onClick={aoLimpar}>
          Limpar filtros ({filtrosAtivos})
        </button>
      )}
    </div>
  );
}
